const STEP = 23;

const gradientStops = [
    { pos: 0, color: "#FADEC4" }, // red
    { pos: 25, color: "#BDF0D5" }, // yellow
    { pos: 50, color: "#D9CCFF" }, // green
    { pos: 75, color: "#FED0D4" }, // cyan
    { pos: 100, color: "#E8EAED" }, // blue
];

const hexToRgb = (hex: string): number[] => {
    hex = hex.replace("#", "");
    return [
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16),
    ];
};

const rgbToHex = ([r, g, b]: number[]): string =>
    "#" + [r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("");

const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

const lerpColor = (c1: number[], c2: number[], t: number): number[] => [
    Math.round(lerp(c1[0], c2[0], t)),
    Math.round(lerp(c1[1], c2[1], t)),
    Math.round(lerp(c1[2], c2[2], t)),
];

const getGradientColor = (position: number): string => {
    // Repeat every 100 units
    const p = ((position % 100) + 100) % 100;

    for (let i = 0; i < gradientStops.length - 1; i++) {
        const a = gradientStops[i];
        const b = gradientStops[i + 1];

        if (p >= a.pos && p <= b.pos) {
            const t = (p - a.pos) / (b.pos - a.pos);
            const rgb = lerpColor(hexToRgb(a.color), hexToRgb(b.color), t);
            return rgbToHex(rgb);
        }
    }

    return gradientStops[0].color;
};

export const getNthColor = (n: number): string => getGradientColor(n * STEP);

// User colors are starting from 1 to not match 1:1 with entity colors
export const getNthUserColor = (n: number): string =>
    getGradientColor((n + 1) * STEP);
